// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/camera'
import 'vue-awesome/icons/barcode'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/volume-up'
import 'vue-awesome/icons/volume-off'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/edit';
import 'vue-awesome/icons/print';
import 'vue-awesome/icons/check-circle';

import Icon from 'vue-awesome/components/Icon'

Vue.component('icon', Icon)

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
  },
  router,
  components: { App },
  template: '<App/>'
})

Vue.directive('focus', {
  inserted: function (el) {
      el.focus()
  }
})

window.addEventListener('popstate', () => {
  app.currentRoute = window.location.pathname
})

const CACHE_NAME = 'offline-cache-v1';
const OFFLINE_API_QUEUE = [];

// Helper: Cache essential assets during install
async function cacheAssets() {
  const cache = await caches.open(CACHE_NAME);
  return cache.addAll([
    '/',             // Adjust as needed
    '/index.html',
    '/styles.css',
    '/main.js'
  ]);
}

// New Helper: Load all data from API and cache it
async function cacheAllData() {
  const cache = await caches.open(CACHE_NAME);
  try {
    const response = await fetch('/api/all');
    if (response.ok) {
      await cache.put('/api/all', response.clone());
      console.log('All data cached successfully');
      return response;
    } else {
      console.error('Failed to fetch all data:', response.statusText);
    }
  } catch (error) {
    console.error('Error caching all data:', error);
  }
}

// Helper: Handle API requests – try network; if offline, queue the call
async function handleApiRequest(event) {
  try {
    return await fetch(event.request);
  } catch (error) {
    // If network fails, queue the request and return a fallback response.
    OFFLINE_API_QUEUE.push(event.request.clone());
    return new Response(JSON.stringify({
      error: 'Offline: API call queued and will be retried when online'
    }), { headers: { 'Content-Type': 'application/json' } });
  }
}

// Helper: Process queued API calls using background sync.
async function processQueue() {
  while (OFFLINE_API_QUEUE.length) {
    const req = OFFLINE_API_QUEUE.shift();
    try {
      await fetch(req);
    } catch (err) {
      // If still offline or an error occurs, re-queue this request and stop processing further.
      OFFLINE_API_QUEUE.unshift(req);
      break;
    }
  }
}

// Install event – caching static assets and loading all data
self.addEventListener('install', event => {
  event.waitUntil(
    Promise.all([
      cacheAssets(),
      cacheAllData()
    ])
  );
  self.skipWaiting();
});

// Activate event – claim clients for immediate control
self.addEventListener('activate', event => {
  event.waitUntil(clients.claim());
});

// Fetch event – serve from cache or network, and queue API calls if offline

self.addEventListener('fetch', event => {
  const request = event.request;
  
  // Check if the request is an API call or flagged by axios via a custom header.
  const isAxiosRequest = request.headers.get('X-Axios-Request') === 'true';
  
  if (request.url.includes('/api/') || isAxiosRequest) {
    event.respondWith(handleApiRequest(event));
    return;
  }
  
  // For non-API requests, try the cache first then network.
  event.respondWith(
    caches.match(request).then(response => response || fetch(request))
  );
});

// Background sync event – process queued API calls when connection is restored.
self.addEventListener('sync', event => {
  if (event.tag === 'apiSync') {
    event.waitUntil(processQueue());
  }
});



// WEBPACK FOOTER //
// ./src/main.js